exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-c94f7db8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/Sticker.vue
// module id = 626
// module chunks = 0